exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".muted[data-v-25c21190]{opacity:.4}", ""]);

// exports
